import React, { useRef } from 'react';

const NavigationItem = ({ links = [], contentLink = null }) => {
    const menuRef = useRef(null);
    const toggleMenu = (e) => {
        e.preventDefault();
        menuRef.current.classList.toggle('navbar__menu--show');
    };
    const additionClass =
        contentLink && contentLink.attributes
            ? contentLink.attributes.cssValue
            : null;
    const selectedClass =
        contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = (link) =>
        link.name || (link.links || []).length > 0;

    return (
        <li className={`navbar__item ${contentLink.name === "Recept" ? "receptLink" : ""}`}>
            <a
                className={`navbar__link ${selectedClass} ${
                    hasChildrenClass || ''
                } ${additionClass || ''}`}
                href={contentLink.url || '#'}
                dangerouslySetInnerHTML={{ __html: contentLink.name }}
            ></a>
            {links.length > 0 && (
                <i
                    className="navbar__icon--caret-right navbar__icon navbar__icon--open"
                    onClick={toggleMenu}
                ></i>
            )}
            {links.length > 0 && (
                <ul className="navbar__menu" ref={menuRef}>
                    <div className="navbar__menu-header">
                        <i
                            className="navbar__icon--caret-left navbar__icon"
                            onClick={toggleMenu}
                        ></i>
                        <span
                            className="navbar__title"
                            onClick={toggleMenu}
                            dangerouslySetInnerHTML={{
                                __html: contentLink.name,
                            }}
                        ></span>
                    </div>
                    {links.length > 0 &&
                        links.map((link) =>
                            hasNameOrChildren(link) && (
                                <NavigationItem
                                    links={link.links}
                                    contentLink={link}
                                    key={link.url}
                                />
                            )
                        )}
                </ul>
            )}
        </li>
    );
};

export default NavigationItem;
